import { AfterContentInit, Component, ContentChildren, EventEmitter, Input, OnDestroy, OnInit, Output, QueryList } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Subscription } from 'rxjs';
import { Log } from 'src/app/core/console.log';
import { PageReq } from 'src/app/models/datatable/page-req';
import { PageRes } from 'src/app/models/datatable/page-res';
import { BaseTableTemplate } from './base/base-table-template';
import { DatatableColumnComponent } from './datatable.column.component';

@Component({
  selector: 'app-datatable',
  templateUrl: './datatable.component.html',
  styleUrls: ['./datatable.component.scss']
})
export class DatatableComponent extends BaseTableTemplate implements OnInit, AfterContentInit, OnDestroy {
  // input config
  @Input() headerTitle: string;
  @Input() headerDroupdown: Boolean;
  @Input() tableStyleClass: string;
  @Input() tableStriped: Boolean;
  @Input() theadStyleClass: string;
  @Input() tbodyStyleClass: string;
  @Input() searchResult: Boolean;

  // output event
  @Output() pageChange: EventEmitter<PageReq> = new EventEmitter();
  @Output() sortChange: EventEmitter<PageReq> = new EventEmitter();

  // for setting column
  @ContentChildren(DatatableColumnComponent) cols: QueryList<DatatableColumnComponent>;
  public columns: DatatableColumnComponent[];
  columnsSubscription: Subscription;

  // data for paging
  pageReq: PageReq;
  pageRes: PageRes<any>;
  currentPage;
  isChangeByItemPerPage = false;
  private _loading: string;
  language: string;

  constructor(
    private ngxLoaderService: NgxUiLoaderService,
    private translateForm: TranslateService,
    ) {
    super();
  }

  @Input()
  set loading(value: string) {
    if (this._loading !== value) {
      this._loading = value;
      this.checkLoading();
    }
  }

  @Input()
  set data(value) {
    this.pageRes = value;
    if (this.pageRes) {
      Log.debug('datatable(content): ', this.pageRes);
      this.currentPage = +this.pageRes.page;
      if (this.pageReq) {
        this.pageReq.page = this.pageRes.page;
        this.pageReq.size = this.pageRes.size;
      }
    }
  }

  get isHasData(): boolean {
    return this.pageRes ? this.pageRes.totalElement > 0 : false;
  }

  ngOnInit() {
    this.pageReq = new PageReq();
    this.language = this.translateForm.currentLang;
    // this.pageRes = new PageRes();
    /*this.pageReq.sorts = [
      { field: 'column1', type: SortType.ASC },
      { field: 'column2', type: SortType.DESC }
    ];*/
    // Log.debug('datatable: ', this.pageRes);
  }

  ngAfterContentInit(): void {
    super.ngAfterContentInit();
    this.initColumns();

    this.columnsSubscription = this.cols.changes.subscribe(_ => {
      Log.debug('ngAfterViewInit - columns change', _);
      this.initColumns();
    });
  }

  ngOnDestroy(): void {
    if (this.columnsSubscription) {
      this.columnsSubscription.unsubscribe();
    }
  }

  initColumns(): void {
    this.columns = this.cols.toArray();
    // this.columnsChanged = true;
  }

  onChangePerPage(record) {
    this.isChangeByItemPerPage = true;
    this.pageReq.page = 1;
    this.pageReq.size = record;
    this.pageChange.emit(this.pageReq);
    // Log.debug('datatable-onChangePerPage: ', this.pageReq);
  }

  onPageChanged(page: any) {
    if (!this.isChangeByItemPerPage && this.currentPage != this.pageRes.page) {
      this.pageReq.page = page;
      this.pageChange.emit(this.pageReq);
      // Log.debug('datatable-onPageChanged: ', this.pageRes);
    }
    this.isChangeByItemPerPage = false;
  }

  private checkLoading() {
    if (this._loading) {
      this.ngxLoaderService.startLoader('table-loader');
    } else {
      this.ngxLoaderService.stopLoader('table-loader');
    }
  }
}
